import React from 'react';
import { Toaster } from '@/components/ui/sonner';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/i18n';
import '@/App.css';
import { AuthProvider, useAuth } from '@/lib/auth';
import AppShell from '@/components/AppShell';
import LoginPage from '@/pages/LoginPage';
import OverviewPage from '@/pages/OverviewPage';
import ServicesPage from '@/pages/ServicesPage';
import ServiceDetailPage from '@/pages/ServiceDetailPage';
import LogsPage from '@/pages/LogsPage';
import IncidentsPage from '@/pages/IncidentsPage';
import MaintenancePage from '@/pages/MaintenancePage';
import DeploymentsPage from '@/pages/DeploymentsPage';
import DatabasePage from '@/pages/DatabasePage';
import AppMonitorPage from '@/pages/AppMonitorPage';
import AppSupportPage from '@/pages/AppSupportPage';
import TicketsPage from '@/pages/TicketsPage';
import AiAgentPage from '@/pages/AiAgentPage';
import CampaignsPage from '@/pages/CampaignsPage';
import WhatsAppPage from '@/pages/WhatsAppPage';
import AppChurchesPage from '@/pages/AppChurchesPage';
import AppFinancePage from '@/pages/AppFinancePage';
import AppFlagsPage from '@/pages/AppFlagsPage';
import AppWebhooksPage from '@/pages/AppWebhooksPage';
import BackupsPage from '@/pages/BackupsPage';
import AlertsPage from '@/pages/AlertsPage';
import UsersPage from '@/pages/UsersPage';
import SettingsPage from '@/pages/SettingsPage';
import AuditPage from '@/pages/AuditPage';

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  return (
    <Protected>
      <AppShell />
    </Protected>
  );
}

function App() {
  return (
    <div className="bomm-app dark">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<Shell />}>
              <Route path="/" element={<OverviewPage />} />
              <Route path="/app-monitor" element={<AppMonitorPage />} />
              <Route path="/app-support" element={<AppSupportPage />} />
              <Route path="/app-tickets" element={<TicketsPage />} />
              <Route path="/ai-agent" element={<AiAgentPage />} />
              <Route path="/campaigns" element={<CampaignsPage />} />
              <Route path="/whatsapp" element={<WhatsAppPage />} />
              <Route path="/app-churches" element={<Protected roles={['admin', 'tech']}><AppChurchesPage /></Protected>} />
              <Route path="/app-finance" element={<Protected roles={['admin', 'tech']}><AppFinancePage /></Protected>} />
              <Route path="/app-flags" element={<Protected roles={['admin']}><AppFlagsPage /></Protected>} />
              <Route path="/app-webhooks" element={<Protected roles={['admin']}><AppWebhooksPage /></Protected>} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/:id" element={<ServiceDetailPage />} />
              <Route path="/logs" element={<LogsPage />} />
              <Route path="/incidents" element={<IncidentsPage />} />
              <Route path="/maintenance" element={<MaintenancePage />} />
              <Route path="/deployments" element={<DeploymentsPage />} />
              <Route path="/database" element={<DatabasePage />} />
              <Route path="/backups" element={<BackupsPage />} />
              <Route path="/alerts" element={<AlertsPage />} />
              <Route path="/users" element={<Protected roles={['admin']}><UsersPage /></Protected>} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/audit" element={<Protected roles={['admin']}><AuditPage /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
